import {
    isoAndUnixZodSchema,
    type IsoAndUnixTimestamp,
} from "@@/shared/date-time/iso-and-unix";
import { ownerIdZodSchema, type OwnerId } from "@@/shared/owner-id";
import { z } from "zod";
import type { PayoutTargetId} from "./payout-target-id";
import { payoutTargetIdZodSchema } from "./payout-target-id";

type _PayoutTargetBase = {
    _id: PayoutTargetId;
    _type: "PAYOUT_TARGET";
    _createdAt: IsoAndUnixTimestamp;
    ownerId: OwnerId;
};

const payoutTargetBaseZodSchema: z.ZodSchema<_PayoutTargetBase> = z.object({
    _id: payoutTargetIdZodSchema,
    _type: z.literal("PAYOUT_TARGET"),
    _createdAt: isoAndUnixZodSchema,
    ownerId: ownerIdZodSchema,
});

export { payoutTargetBaseZodSchema };
export type { _PayoutTargetBase };
